import React from 'react';
import PropTypes from 'prop-types';
import {
  Icon, Spin, Radio,
} from 'antd';
import { Text } from '../../../shared/components';
import Flex from '../../../shared/components/basic/Flex';

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
export default function PasillosBar({
  hide,
  handleChange,
  pasillos,
  loading,
}) {
  if (!hide && loading) return <Flex ml={16} alignItems="baseline"><Spin indicator={antIcon} /></Flex>;

  const showPasillos = pasillos.length !== 0 && !hide;
  const selectedPasillo = pasillos.find(e => e.isSelected);
  const pasillosSinCero = pasillos.filter(e => e.id !== 0);
  const drawPasillos = (pasillos) => {
    const pasillosButtons = pasillos.map(p => <Radio.Button value={p.id}>{p.descripcion}</Radio.Button>);
    return <Radio.Group onChange={v => handleChange(v.target.value)} defaultValue={selectedPasillo.id}>{pasillosButtons}</Radio.Group>;
  };
  return (
    <Flex ml={16} alignItems="baseline" display={!showPasillos ? 'none' : 'flex'}>
      {showPasillos && (<Text mr={16}>Pasillo: </Text>)}
      {showPasillos && (drawPasillos(pasillosSinCero))}
    </Flex>
  );
}

PasillosBar.propTypes = {
  handleChange: PropTypes.func,
  pasillos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    descripcion: PropTypes.string,
    isSelected: PropTypes.bool,
  })).isRequired,
  loading: PropTypes.bool,
  hide: PropTypes.bool,
};
PasillosBar.defaultProps = {
  handleChange: () => {},
  loading: false,
  hide: false,
};
